{
  "manager": {
    "notificationSendPlan": {
      "readyToSend": "Ready to send",
      "sendingTo": "Sending to",
      "except": "except",
      "subject": "Subject",
      "noSubject": "No subject",
      "attachment": "Attachment",
      "channel": "Channel",
      "channelEmail": "Email",
      "family": "Family",
      "includesTeamMembers": "Includes {label}",
      "including": "Including",
      "excluding": "Excluding",
      "deliveryWarning": "Emails begin delivery immediately. You can't recall a sent message.",
      "audienceSentenceWithExcludes": "Sending to {includes} except {excludes}.",
      "audienceSentence": "Sending to {includes}."
    },
    "notificationCreator": {
      "audienceRequired": "Add at least one Include group so this notification has recipients.",
      "saveDraft": "Save Draft",
      "previewAndSend": "Preview & Send",
      "fieldRequired": "This field is required.",
      "subjectLabel": "Subject *",
      "subjectPlaceholder": "Enter your subject",
      "attachmentLabel": "Attachment",
      "attachmentDescription": "Maximum attachment size is 10MB.",
      "attachmentTooLarge": "The selected file is too large. Please choose a file that is 10MB or less.",
      "attached": "Attached",
      "removeAttachment": "Remove Attachment",
      "familyMembersLabel": "Family members",
      "familyMembersDescription": "If checked, the notification will be sent to family members who are associated with the selected audience and have an email address on file.",
      "sendToFamilyMembers": "Send to family members with email addresses",
      "bodyLabel": "Body *",
      "subjectRequired": "A subject is required",
      "bodyRequired": "A message body is required",
      "audienceIncludeRequired": "Add at least one group to the Include rail so this has recipients",
      "audienceNoRecipients": "The selected audience matches 0 recipients. Adjust your Include or Exclude groups.",
      "draftSaveError": "Drafts are unable to be saved without an audience.",
      "unsavedChangesConfirm": "You have unsaved changes. Do you want to save them before leaving?",
      "leaveWithoutSavingConfirm": "Are you sure you want to leave without saving?"
    },
    "notificationView": {
      "backToNotifications": "Back to Notifications",
      "viewNotification": "View Notification",
      "status": "Status",
      "group": "Group",
      "dateSent": "Date Sent",
      "delivered": "Delivered",
      "opened": "Opened",
      "clicked": "Clicked",
      "failed": "Failed",
      "familyMembers": "Family Members",
      "attachment": "Attachment",
      "yourCommunity": "Your community"
    },
    "notificationEmailFrame": {
      "emailPreview": "Email preview",
      "from": "From",
      "subject": "Subject",
      "noSubject": "No subject",
      "to": "To",
      "openInNewTab": "Open in new tab",
      "openInNewTabAria": "Open email preview in a new tab",
      "renderedEmailPreview": "Rendered email preview"
    },
    "notificationReview": {
      "reviewAndSend": "Review and send notification",
      "sendLabel": "Send to {total} recipient | Send to {total} recipients",
      "yourCommunity": "Your community"
    },
    "customNotificationCreate": {
      "titleLabel": "Title *",
      "required": "This field is required.",
      "subjectLabel": "Subject *",
      "bodyLabel": "Body *",
      "editTitle": "Edit Custom Notification",
      "createTitle": "Create Custom Notification",
      "entity": "Custom notification"
    },
    "customNotificationIndex": {
      "title": "Custom Notifications"
    },
    "notificationIndex": {
      "title": "Notifications"
    },
    "notificationRecipients": {
      "title": "Notification Recipients",
      "resendingQueued": "Resending queued...",
      "resendQueued": "Resend Queued",
      "requeuedToast": "Queued recipients requeued."
    },
    "notificationCreate": {
      "editTitle": "Edit Notification",
      "createTitle": "Create Notification",
      "backToEditor": "Back to Editor",
      "backToNotifications": "Back to Notifications",
      "queuedToast": "This email has been queued and will be delivered shortly."
    }
  }
}
